// @mui
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Drawer from "@mui/material/Drawer";
// hooks
import { useTheme } from "@mui/material/styles";
import { useCollapseDrawer } from "hooks/useProvidersHooks";
import { useResponsive } from "hooks/useResponsive";
// theme
import { mixins } from "theme/mixins";
import { createCustomShadow } from "theme/shadows";
// config
import { NavbarConfig } from "constants/NavbarConfig";
import { NAVBAR } from "../../../../../config";
// components
import { Scrollbar } from "components/kit/Scrollbar";
import { Logo } from "components/common/Logo";
import NavbarAccount from "components/layouts/dashboard/Navbar/Vertical/NavbarAccount";
import { NavSectionVertical } from "components/layouts/dashboard/Navbar/Vertical/VerticalNavbarSection";
import { NavbarCollapse } from "components/layouts/dashboard/Navbar/Vertical/NavbarCollapse";
import { BurgerMenu } from "components/layouts/dashboard/Header/BurgerMenu";

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    flexShrink: 0,
    transition: theme.transitions.create("width", {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

export function DashboardVerticalNavbar() {
  const theme = useTheme();

  const isDesktop = useResponsive("up", "lg");

  const {
    isCollapse,
    collapseClick,
    collapseHover,
    isDrawerOpen,
    onCloseDrawer,
  } = useCollapseDrawer();

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        pt: 4,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 3,
          flexShrink: 0,
          ...(isCollapse && { alignItems: "center" }),
        }}
      >
        <Stack
          direction={isCollapse ? "column-reverse" : "row"}
          alignItems="center"
          justifyContent={"space-between"}
          sx={{ mb: 5 }}
          spacing={isCollapse ? 3 : 0}
        >
          <Logo />

          {isDesktop ? <NavbarCollapse /> : <BurgerMenu />}
        </Stack>

        <NavbarAccount />
      </Stack>

      <NavSectionVertical navConfig={NavbarConfig} />
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse
            ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH
            : NAVBAR.DASHBOARD_WIDTH,
        },
        ...(collapseClick && {
          position: "absolute",
        }),
      }}
    >
      {!isDesktop && (
        <Drawer
          open={isDrawerOpen}
          onClose={onCloseDrawer}
          PaperProps={{
            sx: {
              width: NAVBAR.DASHBOARD_WIDTH,
              bgcolor: (theme) => theme.palette.background.default,
              transition: (theme) =>
                theme.transitions.create("width", {
                  duration: theme.transitions.duration.standard,
                }),
              ...mixins(theme).bgBlur(),
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          // onMouseEnter={onHoverEnter}
          // onMouseLeave={onHoverLeave}
          PaperProps={{
            sx: {
              width: NAVBAR.DASHBOARD_WIDTH,
              borderRightStyle: "dashed",
              transition: (theme) =>
                theme.transitions.create("width", {
                  duration: theme.transitions.duration.standard,
                }),
              ...(isCollapse && {
                width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
              }),
              ...(collapseHover && {
                ...mixins(theme).bgBlur(),
                boxShadow: (theme) =>
                  createCustomShadow(theme.palette.primary.main).z24,
              }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
